import { TProDirectoryRevision, TUpdateProDirectory } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';
import { getMyProDirectoryRevisionsQueryKey } from './use-get-my-pro-directory-revisions-query';
import { getProDirectoryPendingRevisionQueryKey } from './use-get-pro-directory-pending-revision-query';

export const useUpdateProDirectoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TUpdateProDirectory) => {
      const res = await axios.patch<TProDirectoryRevision>(`/${TEACHER_DIRECTORY_PATH}`, payload);
      return res.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: getProDirectoryPendingRevisionQueryKey() });
      queryClient.invalidateQueries({ queryKey: getMyProDirectoryRevisionsQueryKey() });
      enqueueSnackbar(
        variables.isDraft ? 'Your draft has been saved.' : 'Your changes have been submitted for review.',
        {
          variant: 'success',
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        },
      );
    },
    meta: {
      errorMessage: 'Unable to submit your pro profile changes. Please try again.',
    },
  });
};
